//const twetchFromAddress = '1HJtxiiGijS3CMBpk6KRsAwCzRk7KVq8fR';
const twetchFromAddress = '17XpmG3keK18LF8Bzpf7MhTEFSiK9QE2Xt';
const twetchWorkSpaceId = '7d113b61-89ce-4c5a-adab-16adb3b5782c';
const twetchClientIdentifier = "bbaf2dac-774c-4741-9f04-81d3ad3df2f6";

export { twetchFromAddress, twetchWorkSpaceId, twetchClientIdentifier };